import React from "react";
import { useNavigate } from "react-router-dom";

const HomeSection1 = () => {
  const navigate = useNavigate();
  return (
    <section className="lg:flex w-full gap-10 mb-16">
      {/* 2 sub card */}
      <div className="lg:w-3/12 sm:w-0 sm:mt-10 lg:mt-0 flex lg:flex-col md:flex-row sm:flex-col  lg:gap-y-10 md:gap-x-10 sm:gap-y-10">
        <div className="text-sm hidden lg:block">
          <p className="border border-gray-300 p-2 font-semibold text-warning">
            Categories
          </p>
          <p className="border border-gray-300 p-2  hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Ciramic Products
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Home Decor
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Wall Decor
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Gift Products
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Mug & Dinner Sets
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Ciramics
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Home Decor
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Wall Decor
          </p>
          <p className="border border-gray-300 p-2 hover:cursor-pointer hover:text-warning  hover:font-semibold">
            Gift Decor
          </p>
        </div>
      </div>
      {/* main card */}
      <div className="bg-warning lg:w-9/12 sm:w-full  flex lg:flex-row md:flex-row sm:flex-col lg:justify-between sm:justify-center items-center p-10 home_sec1_hero shadow-xl">
        <div className="lg:order-1 md:order-1 sm:order-2 w-full text-white flex flex-col  items-center ">
          <div className="text-4xl my-4">
            <p className="text-4xl font-bold">11.11 </p>
            <p className="text-2xl "> Winter Sale Ongoing</p>
            <p className="text-4xl font-bold">Hand Tools Power Saw Machine </p>
            <p className="text-xs mb-4">
              DEWALT 12 Volt Max 3-8 in Cordless Drill Charger Included
            </p>
          </div>

          <button onClick={() => navigate("/shop")} className="btn btn-wide">
            SHOP NOW
          </button>
        </div>
        <div className="lg:order-2 md:order-2 sm:order-1 w-full mb-0 sm:mb-6 flex justify-center">
          <img
            className="w-72 "
            src="https://i.ibb.co/1KbySnR/asdasdasdasdasdasdasd.png"
            alt=""
          />
        </div>
      </div>
    </section>
  );
};

export default HomeSection1;
